/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiFieldConfig} from "./UiFieldConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiFileFieldDisplayType} from "./UiFileFieldDisplayType";
import {UiFieldSubCommandHandler} from "./UiFieldConfig";


export interface UiFileFieldConfig extends UiFieldConfig {
	_type?: string;
	itemTemplate: UiTemplateConfig;
	maxBytesPerFile?: number;
	uploadUrl?: string;
	fileTooLargeMessage?: string;
	uploadErrorMessage?: string;
	displayType?: UiFileFieldDisplayType;
	maxFiles?: number;
	uploadButtonTemplate: UiTemplateConfig;
	uploadButtonData: any;
	showEntriesAsButtonsOnHover?: boolean;
	uuidPropertyName?: string
}

export interface UiFileFieldSubCommandHandler extends UiFieldSubCommandHandler {
	replaceFileItem(uuid: string, data: any): void;
	setItemTemplate(itemTemplate: UiTemplateConfig): void;
	setMaxBytesPerFile(maxBytesPerFile: number): void;
	setUploadUrl(uploadUrl: string): void;
	setDisplayType(displayType: UiFileFieldDisplayType): void;
	setMaxFiles(maxFiles: number): void;
	setUploadButtonTemplate(uploadButtonTemplate: UiTemplateConfig): void;
	setUploadButtonData(uploadButtonData: any): void;
	setShowEntriesAsButtonsOnHover(showEntriesAsButtonsOnHover: boolean): void;
}

export interface UiFileFieldSubEventSource {
	onFileUploaded: TeamAppsEvent<UiFileField_FileUploadedSubEvent>;
	onFileUploadError: TeamAppsEvent<UiFileField_FileUploadErrorSubEvent>;
	onFileClicked: TeamAppsEvent<UiFileField_FileClickedSubEvent>;
	onFileRemoveButtonClicked: TeamAppsEvent<UiFileField_FileRemoveButtonClickedSubEvent>;
}

export interface UiFileField_FileUploadedSubEvent extends UiSubEvent {
	_type: "UiFileField.fileUploaded";
	redundancyKey?: string;
	fileUuid: string;
	name: string;
	mimeType: string;
	sizeInBytes: number
}

export interface UiFileField_FileUploadErrorSubEvent extends UiSubEvent {
	_type: "UiFileField.fileUploadError";
	redundancyKey?: string;
	name: string;
	mimeType: string;
	sizeInBytes: number
}

export interface UiFileField_FileClickedSubEvent extends UiSubEvent {
	_type: "UiFileField.fileClicked";
	redundancyKey?: string;
	buttonData: any
}

export interface UiFileField_FileRemoveButtonClickedSubEvent extends UiSubEvent {
	_type: "UiFileField.fileRemoveButtonClicked";
	redundancyKey?: string;
	buttonData: any
}
